<template>
  <div>
    <TextInput
      label="First Name"
      placeholder="Elon"
      @update:modelValue="update('firstName', $event)"
      :modelValue="modelValue.firstName"
    />
    <TextInput
      class="mt-4"
      label="Last Name"
      placeholder="Husk"
      @update:modelValue="update('lastName', $event)"
      :modelValue="modelValue.lastName"
    />
    <PhoneInput
      class="mt-4"
      label="Phone Number"
      placeholder="+1 (281) 330 8004"
      :modelValue="modelValue.phone"
      @update:modelValue="update('phone', $event)"
    />
    <TextInput
      class="mt-4"
      label="Email"
      placeholder="you@example.com"
      @update:modelValue="update('email', $event)"
      :modelValue="modelValue.email"
    />
    <SelectMenu
      class="mt-4"
      label="Stage"
      :initialValue="modelValue.stage ? modelValue.stage : 'Applied'"
      :options="[
        'Applied',
        'Phone Screen',
        'Interview',
        'Onboarding',
        'Hired',
        'Nurture',
        'Declined',
        'Disqualified',
        'Unlicensed',
        'Unlicensed with Coursework Started',
      ]"
      @selectedOption="update('stage', $event)"
    />
    <TextInput
      class="mt-4"
      label="RE License Number"
      placeholder="123456"
      :optional="true"
      @update:modelValue="update('reLicenseNumber', $event)"
      :modelValue="modelValue.reLicenseNumber"
    />
    <DateTimeInput
      class="mt-4"
      label="Phone Screen At"
      :optional="true"
      @update:modelValue="update('phoneScreenAt', $event)"
      :modelValue="modelValue.phoneScreenAt"
    />
    <DateTimeInput
      class="mt-4"
      label="Interview At"
      :optional="true"
      @update:modelValue="update('interviewAt', $event)"
      :modelValue="modelValue.interviewAt"
    />
  </div>
</template>

<script>
export default {
  props: ['modelValue'],
  data() {
    return {
      showValidation: false,
    };
  },
  methods: {
    update(key, value) {
      this.$emit('update:modelValue', { ...this.modelValue, [key]: value });
    },
  },
};
</script>
